/**
 * TanStack Router: /workforce/departments/new
 *
 * Create new department form
 * Layout: Authenticated (_auth)
 *
 * @see src/app/workforce/departments/new/page.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import NewDepartmentPage from '@/app/workforce/departments/new/page'

/**
 * Route: /workforce/departments/new
 * Layout: _auth (authenticated)
 * Component: NewDepartmentPage
 */
export const Route = createFileRoute('/_auth/workforce/departments/new')({
  component: NewDepartmentPage,
})
